export var ScanJobType;
(function (ScanJobType) {
    ScanJobType["ScanJobTypeUnspecified"] = "SCAN_JOB_TYPE_UNSPECIFIED";
    ScanJobType["AwsEc2Scan"] = "AWS_EC2_SCAN";
    ScanJobType["AwsEbsVolumeScan"] = "AWS_EBS_VOLUME_SCAN";
    ScanJobType["AwsRdsScan"] = "AWS_RDS_SCAN";
    ScanJobType["AwsS3Scan"] = "AWS_S3_SCAN";
    ScanJobType["AwsDynamoDbScan"] = "AWS_DYNAMO_DB_SCAN";
    ScanJobType["AwsEksNamespaceScan"] = "AWS_EKS_NAMESPACE_SCAN";
    ScanJobType["AzureStorageAccountScan"] = "AZURE_STORAGE_ACCOUNT_SCAN";
    ScanJobType["AzureVmScan"] = "AZURE_VM_SCAN";
    ScanJobType["AzureSqlDatabaseScan"] = "AZURE_SQL_DATABASE_SCAN";
    ScanJobType["AzureSqlVirtualMachineScan"] = "AZURE_SQL_VIRTUAL_MACHINE_SCAN";
    ScanJobType["GcpComputeEngineInstanceScan"] = "GCP_COMPUTE_ENGINE_INSTANCE_SCAN";
    ScanJobType["GcpDiskScan"] = "GCP_DISK_SCAN";
    ScanJobType["GcpCloudStorageScan"] = "GCP_CLOUD_STORAGE_SCAN";
    ScanJobType["GcpCloudSqlScan"] = "GCP_CLOUD_SQL_SCAN";
    ScanJobType["GcpBigqueryScan"] = "GCP_BIGQUERY_SCAN";
    ScanJobType["AtlasMongodbClusterScan"] = "ATLAS_MONGODB_CLUSTER_SCAN";
    ScanJobType["Microsoft365Scan"] = "MICROSOFT_365_SCAN";
})(ScanJobType || (ScanJobType = {}));
